import { render, staticRenderFns } from "./ChangeLanguageLoading.vue?vue&type=template&id=4415b806"
import script from "./ChangeLanguageLoading.vue?vue&type=script&lang=js"
export * from "./ChangeLanguageLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports